import { FC } from "react"

interface ChatbotUISVGProps {
  theme: "dark" | "light"
  scale?: number
  height?: number
  width?: number
  className?: string
}

export const ChatbotUISVG: FC<ChatbotUISVGProps> = ({
  height = 80,
  width = 80,
  className,
  theme,
  scale = 1
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 306.2 263.76"
      overflow="visible"
    >
      <defs>
        <style>
          {`
            .cls-1 {
              fill: #040404;
            }

            .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {
              stroke-width: 0px;
            }

            .cls-2 {
              fill: #ef5c5d;
            }

            .cls-3 {
              fill: #141414;
            }

            .cls-4 {
              fill: #f9f8f8;
            }

            .cls-5 {
              fill: #fdfdfd;
            }
          `}
        </style>
      </defs>
      <path
        className="cls-4"
        d="M42.07,221.87c-8.71.24-16.68-1.3-23.76-5.93C6.97,208.52,0.16,198.22,0.12,184.43-.02,135.16-.06,85.89,0.12,36.62,0.2,15.63,19.76.09,37.63.15,113.72.39,189.81.59,265.89,0c18.3-.14,40.12,13.67,40.18,39.59.11,47.52.25,95.05-.06,142.57-.15,23.49-17.28,39.68-40.85,39.68-36.05,0-72.1-.02-108.15.05-2.04,0-4.2.43-6.1,1.19-33.14,13.21-66.27,26.46-99.35,39.81-5.51,2.22-9.86.21-9.61-6.5.42-11.33.12-22.68.12-34.52ZM52.58,250.95c1.22-.48,2.13-.82,3.03-1.18,30.94-12.39,61.87-24.81,92.84-37.12,2.23-.89,4.8-1.31,7.21-1.32,36.18-.08,72.36-.03,108.53-.1,3.34,0,6.78-.2,9.99-1.03,13.43-3.5,21.28-14.45,21.29-29.54.04-46.53.03-93.06-.02-139.59,0-2.84-.19-5.77-.9-8.5-3.65-14.11-13.92-21.89-28.94-21.9-75.1-.03-150.2-.04-225.3,0-18.05,0-29.95,11.73-30,29.87-.12,46.91-.05,93.81-.04,140.72,0,9.59,3.24,17.7,10.9,23.84,6.75,5.41,14.62,6.31,22.85,6.2,7.08-.09,8.54,1.42,8.54,8.4,0,10.32,0,20.63,0,31.25Z"
      />
      <path
        className="cls-1"
        d="M52.58,250.95c0-10.62,0-20.94,0-31.25,0-6.99-1.46-8.5-8.54-8.4-8.23.11-16.1-.79-22.85-6.2-7.67-6.14-10.9-14.26-10.9-23.84-.02-46.91-.09-93.81.04-140.72.05-18.14,11.95-29.86,30-29.87,75.1-.04,150.2-.03,225.3,0,15.03,0,25.3,7.79,28.94,21.9,.71,2.73,.89,5.66,.9,8.5,.05,46.53,.06,93.06,.02,139.59-.01,15.09-7.86,26.04-21.29,29.54-3.2.84-6.65,1.02-9.99,1.03-36.18,.07-72.36,.02-108.53,.1-2.41,0-4.98.43-7.21,1.32-30.97,12.31-61.9,24.73-92.84,37.12-.9.36-1.81.71-3.03,1.18ZM236.94,107.43c-7.17,5.7-14.7,7.98-22.73,8.68-5.83.51-11.7.47-17.53.98-4.2.37-6.87-1.47-8.83-4.89-2.95-5.17-5.9-10.35-8.86-15.52-12.19-21.2-24.37-42.4-36.6-63.58-3.41-5.9-5.89-5.84-9.43.06-.06.11-.12.22-.19.33-20.65,35.8-41.29,71.6-61.92,107.42-.77,1.34-1.37,2.79-2.23,4.58,2.01,0,3.37,0,4.74,0,31.31,0,62.62,.08,93.93-.08,4.97-.03,8.06,1.68,10.48,6.03,7.48,13.45,15.24,26.74,22.99,40.04,.64,1.11,2.01,2.53,3.06,2.55,10.31,.19,20.63,.12,31.37,.12-9.25-16.16-18.29-31.98-27.84-48.66,2.33,0,3.57,.19,4.73-.03,7.53-1.45,15.07-2.92,22.55-4.61,.93-.21,2.2-1.75,2.21-2.69,.16-9.94,.1-19.89,.1-30.71ZM221.05,80.73c1.19-7.93-6.48-17.57-17.21-17.39-9.71.16-17.24,7.59-17.26,17.2-.02,9.97,7.34,17.47,17.26,17.58,9.88.12,17.21-7.29,17.22-17.39Z"
      />
      <path
        className="cls-5"
        d="M236.94,107.43c0,10.82,.06,20.76-.1,30.71-.02,.94-1.29,2.48-2.21,2.69-7.48,1.69-15.02,3.16-22.55,4.61-1.16,.22-2.4,.03-4.73,.03,9.54,16.68,18.59,32.5,27.84,48.66-10.73,0-21.05,.08-31.37-.12-1.05-.02-2.41-1.44-3.06-2.55-7.75-13.3-15.51-26.59-22.99-40.04-2.42-4.35-5.51-6.06-10.48-6.03-31.31,.16-62.62,.08-93.93,.08-1.36,0-2.73,0-4.74,0,.86-1.79,1.45-3.24,2.23-4.58,20.63-35.81,41.28-71.61,61.92-107.42,.06-.11,.12-.22,.19-.33,3.54-5.9,6.02-5.96,9.43-.06,12.23,21.17,24.41,42.38,36.6,63.58,2.97,5.16,5.91,10.35,8.86,15.52,1.95,3.42,4.63,5.26,8.83,4.89,5.83-.51,11.7-.48,17.53-.98,8.03-.7,15.56-2.98,22.73-8.68ZM137.7,82.15c-6.72,11.68-13.12,22.81-19.75,34.35h39.39c-6.59-11.53-12.97-22.69-19.63-34.35Z"
      />
      <path
        className="cls-2"
        d="M221.05,80.73c0,10.11-7.34,17.51-17.22,17.39-9.92-.12-17.28-7.62-17.26-17.58.02-9.61,7.55-17.04,17.26-17.2,10.73-.18,18.41,9.46,17.21,17.39Z"
      />
      <path
        className="cls-3"
        d="M137.7,82.15c6.67,11.67,13.04,22.82,19.63,34.35h-39.39c6.64-11.55,13.04-22.67,19.75-34.35Z"
      />
    </svg>
  )
}
